import { areIntervalsOverlapping, isValid, isBefore } from 'date-fns';

export type ParsableDate = string | number | Date;

export type DateTimeFormat = 'YearMonthDateTime' | 'YearMonthDate' | 'YearMonth' | 'Year';

export function parseDate(parsableDate: null, resolution?: DateTimeFormat): null;
export function parseDate(parsableDate?: undefined, resolution?: DateTimeFormat): undefined;
export function parseDate(parsableDate?: null | undefined, resolution?: DateTimeFormat): null | undefined;
export function parseDate(parsableDate: ParsableDate, resolution?: DateTimeFormat): Date;
export function parseDate(parsableDate: ParsableDate | null, resolution?: DateTimeFormat): Date | null;
export function parseDate(parsableDate?: ParsableDate | undefined, resolution?: DateTimeFormat): Date | undefined;
export function parseDate(parsableDate?: ParsableDate | null, resolution?: DateTimeFormat): Date | undefined | null;
export function parseDate(parsableDate?: ParsableDate | null, resolution: DateTimeFormat = 'YearMonthDateTime'): Date | undefined | null {
  if (parsableDate === undefined) {
    return undefined;
  }
  if (parsableDate === null) {
    return null;
  }

  const date = parsableDate instanceof Date ? parsableDate : new Date(parsableDate);

  if (!isValid(date)) {
    return undefined;
  }

  switch (resolution) {
    case 'Year':
      return new Date(date.getFullYear(), 0 /* January */, 1, 12);

    case 'YearMonth':
      return new Date(date.getFullYear(), date.getMonth(), 1, 12);

    case 'YearMonthDate':
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12);

    case 'YearMonthDateTime':
    default:
      return date;
  }
}

export type OpenInterval =
  | { start: ParsableDate; end: ParsableDate }
  | { start: ParsableDate; end?: ParsableDate }
  | { start?: ParsableDate; end: ParsableDate };

export const minDate = new Date(-8640000000000000);
export const maxDate = new Date(8640000000000000);

export function isValidOpenInterval(interval?: Partial<OpenInterval>): interval is OpenInterval {
  if (!interval) {
    return false;
  }

  const { start, end } = interval;
  if ((start && !isValid(start)) || (end && !isValid(end))) {
    return false;
  }

  const result = (!!start || !!end) && (!start || !end || isBefore(parseDate(start), parseDate(end)));
  if (result) {
    return true;
  }

  return false;
}

export function areOpenIntervalsOverlapping(
  intervalLeft: OpenInterval,
  intervalRight: OpenInterval,
  options?: {
    inclusive?: boolean;
  }
): boolean {
  return areIntervalsOverlapping(
    { start: parseDate(intervalLeft.start ?? minDate), end: parseDate(intervalLeft.end ?? maxDate) },
    { start: parseDate(intervalRight.start ?? minDate), end: parseDate(intervalRight.end ?? maxDate) },
    options
  );
}
